
export default class MonitoringTitleBarViewModel {
    public customerId: string = '';
    public client: string = '';
    public channel: string = '';
    public agentName: string = '';
    public eventTime: Date;
    public result: string = '';
    public tags: string[] = [];
    public telephone: string = '';
}
